<template>
  <div class="select-day">
    <div class="select-name" v-show="displayLabel">
      <slot name="label">日期</slot>
    </div>
    <div class="select-wrap">
      <div class="input-box">
        <input
          readonly
          v-model="selectedName"
          @click="openBox = !openBox"
          @blur="openBox = false"
        />
        <img
          class="arrows"
          :class="[openBox ? 'open' : 'close']"
          src="../../images/mobile/icon_select_up.png"
        />
      </div>
      <div class="ul-box" v-show="openBox" v-if="noRepeatSelect">
        <p
          v-for="(item, index) in selectArr"
          :class="{
            active: selectedName == item.name,
            disabled: selectedArr.includes(item.value),
          }"
          @mousedown="selectFn(item)"
          :key="index"
          :disabled="noRepeatSelect && selectedArr.includes(item.value)"
        >
          {{ item.name }}
        </p>
      </div>
      <div class="ul-box" v-show="openBox" v-else>
        <p
          v-for="(item, index) in selectArr"
          :class="{ active: selectedName == item.name }"
          @mousedown="selectFn(item)"
          :key="index"
        >
          {{ item.name }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Selector',
  props: {
    displayLabel: {
      type: Boolean,
      defualt() {
        return true;
      },
    },
    selectArr: {
      type: Array,
      defualt() {
        return [];
      },
    },
    noRepeatSelect: {
      // 不可重复选择。和 selectedArr 配合使用
      type: Boolean,
      defualt() {
        return false;
      },
    },
    selectedArr: {
      type: Array,
      defualt() {
        return [];
      },
    },
    currVal: {
      type: Number,
      defualt() {
        return '';
      },
    },
    preTips: {
      type: String,
      defualt() {
        return '-请选择-';
      },
    },
  },
  data() {
    return {
      openBox: false,
      selectedName: this.preTips,
    };
  },
  mounted() {
    console.log('Selector mounted---', this.selectedArr, this.noRepeatSelect);
    // console.log('Selector mounted---', this.currVal, this.selectArr);
    this.selectedName = this.preTips || '-请选择-';
    // console.log('Selector beforeCreate---', this.selectedName);
    if (this.currVal || this.currVal === 0) {
      const item = this.selectArr.filter(val => val.value === this.currVal)[0];
      this.selectFn(item);
    }
  },
  methods: {
    selectFn(item) {
      if (this.noRepeatSelect) {
        if (this.selectedArr.includes(item.value)) {
          return this.$toast('请勿重复选择');
        }
      }
      this.selectedName = item.name;
      this.$emit('change', item);
    },
  },
};
</script>
<style lang="scss" scoped>
.select-day {
  // margin-top: 33px;
  display: flex;
  font-size: 26px;
  align-items: center;
  .select-name {
    margin-right: 42px;
  }
  .select-wrap {
    .input-box {
      position: relative;
      display: flex;
      align-items: center;
      .arrows {
        position: absolute;
        right: 10px;
        width: 20px;
        height: 20px;

        transition: all 0.5s ease;
      }
      .arrows.close {
        transform: rotate(180deg);
      }
      .arrows.open {
        transform: rotate(0deg);
      }
    }
    input {
      padding: 0 20px;
      width: 200px;
      height: 56px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
    }

    .ul-box {
      z-index: 101;
      position: absolute;
      width: fit-content;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
      border-radius: 4px;
      max-height: 500px;
      overflow-y: scroll;
      p {
        height: 56px;
        line-height: 56px;
        text-align: center;
        width: fit-content;
        white-space: nowrap;
        padding: 0 16px;
        &.disabled {
          color: #d9d9d9;
        }
        &.active {
          color: #fd9b21;
        }
      }
      .activeDay {
        color: #fd9b21;
        background-color: #fff5e8;
      }
    }
  }
}
</style>
